import { render, staticRenderFns } from "./BroadcastPictures.vue?vue&type=template&id=0695a086&"
import script from "./BroadcastPictures.vue?vue&type=script&lang=js&"
export * from "./BroadcastPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports